import { render, staticRenderFns } from "./VendorApplication.vue?vue&type=template&id=4de0dd61"
import script from "./VendorApplication.vue?vue&type=script&lang=js"
export * from "./VendorApplication.vue?vue&type=script&lang=js"
import style0 from "./VendorApplication.vue?vue&type=style&index=0&id=4de0dd61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports